/** Port von `Pages/Auth/AuthErrorNoUser.razor`. */

import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/auth/useAuth';
import { Button } from '@/components/ui';

export function ErrorNoUser(): ReactElement {
  const auth = useAuth();
  const navigate = useNavigate();

  const goToApps = (): void => {
    auth.setCurrentApp(null);
    void navigate('/authentication/apps');
  };

  const logout = async (): Promise<void> => {
    await auth.logout();
    void navigate('/authentication/logout');
  };

  return (
    <div className="iwm-card">
      <h3>Fehler</h3>
      <span>
        Ihr Benutzer wurde für die Applikation <b>{auth.currentApp?.Name}</b> noch nicht aktiviert.
      </span>
      <div style={{ marginTop: '1rem', display: 'inline-flex', columnGap: '.5rem' }}>
        <Button onClick={goToApps}>Meine Applikationen</Button>
        <Button primary onClick={logout}>
          Ausloggen
        </Button>
      </div>
    </div>
  );
}

export default ErrorNoUser;
